var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row overview-loader"},[_c('div',{staticClass:"col text-center"},[_c('img',{attrs:{"src":"/themes/custom/ef2_custom/img/cp-icon.svg","alt":"Loader"}})])])
}]

export { render, staticRenderFns }